/**
 * Filename: home.js
 * Home page
 * Component path
 * IconBoxed  'componenet/iconboxes.js'
 * Charts compoenent from 'compoenent/charts'
 * Table from 'containers/table.js'
 */

import React, {Component} from 'react';
import IconBoxes from '../../components/iconBoxes.js';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import Panel from '../../components/panel.js';

import ManagerLawyerPerformance from '../../components/tables/managerLawyerPerformance.js';
import RegistrationMatrix from '../../components/tables/registrationMatrix.js';
import DailyAccumulatedIncome from '../../components/dailyAccumulatedIncome';
import {Redirect} from 'react-router';
import {ROL} from '../../utils/constants';
import classNames from "classnames";
import ReoPlaza from '../../components/tables/reoPlaza';

class PlaceOperation extends Component {

  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData, date: new Date()}
  }

  callbackForSelectors = (dataFromChild) => {
    this.setState({date: dataFromChild});
  };

  panelClass = classNames({
    'readmin-panel': true,
  });

  render() {

    let urlPlace = '';
    if(this.props.match.params.vp === 'Culiacán'){
      urlPlace = 'https://app.powerbi.com/view?r=eyJrIjoiZWRhOWNiZDQtMjJiNy00MWE3LThkOTEtYTg0M2VhOWI2MjFkIiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9'
    } else if (this.props.match.params.vp === 'Vallarta'){
      urlPlace = 'https://app.powerbi.com/view?r=eyJrIjoiNWFlY2U4NjItZDA3ZS00ZGU0LWI1NDktYzc5ZGNmNTcyZGI3IiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9'
    } else if (this.props.match.params.vp === 'Tijuana'){
      urlPlace = 'https://app.powerbi.com/view?r=eyJrIjoiM2YyMGJlMmItMTcyZC00MmM2LWJjOWQtOTZmMWZjNDY1NTI2IiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9'
    } else if (this.props.match.params.vp === 'Tuxpan'){
      urlPlace = 'https://app.powerbi.com/view?r=eyJrIjoiMTY5OWQyZTItYzNlZC00MzI5LThjZWYtYzAwOWYwMWNmZDE0IiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9'
    }

    var result;
    if (this.state.userData.rol === ROL.OPERATION.url || this.state.userData.rol === ROL.MANAGEMENT.url || this.state.userData.rol === ROL.SUPERVISOR.url || this.state.userData.rol === ROL.DIRECTION.url) {
      result = <div>
        <SidebarMenuRouters profile="/direction-home/"
                            place={this.props.match.params.vp}/>
        <Header userName={this.state.userData.name} title={"Monitoreo operativo"}/>
        {/*<div className="grid-data-dash">
          <IconBoxes bu={this.props.match.params.vp} callbackFromParent={this.callbackForSelectors}/>
          <div className="row">

            <div className="col-sm-12">
              <Panel title={"Ingreso acumulado diario"} righticon={false}>
                <DailyAccumulatedIncome key={this.state.date + '4'} bu={this.props.match.params.vp}
                                        date={this.state.date}/>
              </Panel>
            </div>

            <div className="col-sm-12">
              <div className={'container-flex'}>
                <div className={this.panelClass}>
                  <ReoPlaza key={this.state.date + '1'} bu={this.props.match.params.vp} date={this.state.date}
                            bordered={true} striped={true}/>
                </div>
              </div>
            </div>

            <div className="col-sm-12">
              <Panel title="Ingreso de gestiones" righticon={false}>
                <ManagerLawyerPerformance key={this.state.date + '2'} striped={true} bu={this.props.match.params.vp}
                                          date={this.state.date}/>
              </Panel>
            </div>

            <div className="col-sm-12">
              <div className={'container-flex'}>
                <div className={this.panelClass}>
                  <RegistrationMatrix key={this.state.date + '3'} striped={true} bu={this.props.match.params.vp}
                                      date={this.state.date}/>
                </div>
              </div>
            </div>
            </div>
                    </div>
*/}
        <div className='d-flex justify-content-start'>
          <iframe width="1880" height="3080"
                  src={urlPlace} frameBorder="0" allowFullScreen="true"/>
        </div>
      </div>
    } else {
      result = <Redirect to={"/"}/>
    }

    return (
      <div>
        {result}
      </div>
    );
  }
}

export default PlaceOperation;



// WEBPACK FOOTER //
// ./src/scene/operation/placeOperation.js